<nav class="static flex xl:relative" [attr.aria-label]="ariaLabel">
  <!-- VERTICAL -->
  <ol
    class="absolute -left-[280px] hidden shrink-0 flex-col items-start justify-start gap-14 gap-y-0 pb-6 pl-10 pr-10 pt-6 text-base xl:flex"
    data-testid="stepper-root"
  >
    @for (step of steps; track step; let i = $index; let last = $last) {
      @let active = selectedIndex === i;
      @let isIncomplete = !active && !step.completed;
      <li
        class="flex shrink-0 flex-row flex-wrap items-center gap-3 gap-y-0 self-stretch"
        (click)="selectStepByIndex(i)"
        [attr.data-testid]="'csl-step-' + step.label"
        [attr.e2e-current]="active"
        [attr.e2e-data-completed]="step.completed"
      >
        <button
          type="button"
          [attr.aria-current]="active ? 'step' : null"
          [attr.aria-labelledby]="'step-label-' + i"
          [attr.aria-disabled]="isIncomplete"
          [ngClass]="
            active || step.completed
              ? 'bg-green-600 text-blue-900'
              : 'border border-blue-300 bg-transparent text-blue-300'
          "
          class="flex h-8 w-8 items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          @if (step.completed) {
            <i class="g-filter-blue-900 block h-6 w-6 bg-[url(../assets/icons/checkmark.svg)] bg-center"></i>
          } @else {
            <span>{{ i + 1 }}</span>
          }
        </button>
        <span
          id="step-label-{{ i }}"
          [ngClass]="active ? 'text-white' : 'text-blue-300'"
          class="flex flex-row items-center p-1"
        >
          {{ step?.label }}
          @if (step.completed) {
            <span class="sr-only">, completed step</span>
          } @else if (isIncomplete) {
            <span class="sr-only">, incomplete step</span>
          }
        </span>
        @if (!last) {
          <hr
            [ngClass]="active ? 'border-green-600' : 'border-blue-300'"
            class="mb-2 ml-4 mt-2 block h-10 basis-full border-l border-t-0"
          />
        }
      </li>
    }
  </ol>

  <!-- HORIZONTAL -->
  <ol
    class="mb-8 mt-5 flex w-full flex-row items-start justify-center gap-14 gap-y-0 text-base md:gap-6 xl:hidden"
    data-testid="stepper-root"
  >
    @for (step of steps; track step; let i = $index; let last = $last) {
      @let active = selectedIndex === i;
      @let isIncomplete = !active && !step.completed;

      <li
        class="relative flex shrink-0 basis-12 flex-col items-center gap-y-2 self-stretch md:basis-40"
        (click)="selectStepByIndex(i)"
        [attr.data-testid]="'csl-step-' + step.label"
        [attr.e2e-current]="active"
        [attr.e2e-data-completed]="step.completed"
      >
        @if (!last) {
          <hr
            [ngClass]="active || step.completed ? 'border-green-600' : 'border-blue-300'"
            class="absolute left-[48px] top-4 w-14 border-t md:left-28 md:w-[120px]"
          />
        }
        <button
          type="button"
          [attr.aria-current]="active ? 'step' : null"
          [attr.aria-labelledby]="'step-label-horizontal-' + i"
          [attr.aria-disabled]="isIncomplete"
          [ngClass]="
            active || step.completed
              ? 'bg-green-600 text-blue-900'
              : 'border border-blue-300 bg-transparent text-blue-300'
          "
          class="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        >
          @if (step.completed) {
            <i class="g-filter-blue-900 block h-6 w-6 bg-[url(../assets/icons/checkmark.svg)] bg-center"></i>
          } @else {
            <span>{{ i + 1 }}</span>
          }
        </button>

        <span
          id="step-label-horizontal-{{ i }}"
          [ngClass]="active ? 'text-white' : 'text-blue-300'"
          class="hidden flex-row items-center p-1 md:flex"
        >
          {{ step?.label }}
          @if (step.completed) {
            <span class="sr-only">, completed step</span>
          } @else if (isIncomplete) {
            <span class="sr-only">, incomplete step</span>
          }
        </span>
      </li>
    }
  </ol>
</nav>

<!-- CONTENT -->
<!-- ngTemplateOutlet nested in ng-container so stamped content is a real child of #stepContent, not a sibling -->
<div #stepContent [ngClass]="containerClasses">
  <ng-container [ngTemplateOutlet]="selected ? selected.content : null" />
</div>
<span class="sr-only" tabindex="-1" #stepHeading>
  {{ selected?.label }}
</span>
